import { METERS_PER_SEC_TO_MPH_FACTOR } from 'features/weatherStations/weatherStations.constants';
import { parseNumericValue } from '../parseNumericValue';

export const convertMetersPerSecToMph = (
  metersPerSec: number,
  factionDigits = 1,
): string => {
  const mph = metersPerSec * METERS_PER_SEC_TO_MPH_FACTOR;
  return parseNumericValue(mph, factionDigits);
};
